export default "__VITE_ASSET__D2$cIM3X__"